
import React, { useEffect } from "react";
// TableFooter, TextField 
// import InputMask from 'react-input-mask';

import { AppBar, Box, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
import ApiHelper from '../../../utility/ApiHelper';
// import APIURLConstants from '../../config/config';
import Paper from '@mui/material/Paper';
import { updateModuleState } from '../../../stores/eventStore';
import { createState, useState } from '@hookstate/core';
import Title from "../../../sharedcomponents/title/title";
import Helper from "../../../utility/helper";
import APIURLConstants from "../../../config/config";
import validator from 'validator';
import { useHistory } from "react-router-dom";
import { VIEW_PERMISSION } from "../../../constants/Constant";
import PhoneNumber from "../../../sharedcomponents/PhoneNumber/phoneNumber";
import { ticketHelper } from '../ticketHelper';
// import RouteConstants from "../../../constants/routeConstants";
//  import { createTheme } from '@mui/material/styles';
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
// const theme = createTheme();
const compTicketState = createState({
    name: '',
    email: '',
    phone: '',
    status: 0
});
const appBarStyle = {
    mb: 1,
    boxShadow: 'none',
    pt: 1,
    pb: 1,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
};
const useStyles = makeStyles(() => ({


    borderSizeColor: {
        // border: '1px solid black',
        // color: 'white',
        // fontSize: 17,
        // fontWeight: 700
    },
}));

const Complimentary = (props) => {

    const classes = useStyles();
    const state = useState(compTicketState);

    const history = useHistory();
    const [compNameError, setCompNameError] = React.useState('');
    const [compEmailError, setCompEmailError] = React.useState('');
    const [compPhoneError, setCompPhoneError] = React.useState('');
    const [compCount, setCompCount] = React.useState(0);
    const eventInfo = Helper.getStorage('eventInfo');
    const [hideSubmitButton, setHideSubmitButton] = React.useState(true);
    // const userInfo = Helper.getStorage('userInfo');

    useEffect(() => {
        return () => {
            reset();
        }
    }, [])

    useEffect(() => {
        if (props && Object.keys(props.newSettingData || {}).length !== 0) {
            const parseData = JSON.parse(props?.newSettingData)
            setCompCount(parseData[0])
            // console.log("parseData",JSON.parse(parseData[0].TicketSetting));
        }
    }, [props.newSettingData])

    useEffect(() => {
        // const userInfo = Helper.getStorage('userInfo');


        if (history.location.state && history.location.state.ticketState != null) {
            // console.log("into state",history.location.state.ticketState);
            const ticketInfo = history.location.state.ticketState;
            // console.log("props?.compData",props?.compData);
            if (props?.compData !== null) {
                state.set({
                    name: props.compData.contactName !== undefined ? props.compData.contactName : "",
                    email: props.compData.contactEmail !== undefined ? props.compData.contactEmail : "",
                    phone: props.compData.contactNo !== undefined ? props.compData.contactNo : "",
                    compID: props.compData.ticketAllStarComplimentaryID,
                    status: props.compData.status ? props.compData.status : 0
                });
            } else {
                state.set({
                    name: ticketInfo.contactName,
                    email: ticketInfo.contactEmail,
                    phone: ticketInfo.contactNo,
                    compID: ticketInfo.ticketAllStarComplimentaryID,
                    status: ticketInfo ? ticketInfo.status : 0
                });
            }
            setHideSubmitButton(true)
        } else {
            // console.log("into else");
            if (props?.compData !== null) {
                state.set({
                    name: props.compData.contactName !== undefined ? props.compData.contactName : state.get().name ? state.get().name : "",
                    email: props.compData.contactEmail !== undefined ? props.compData.contactEmail : state.get().email ? state.get().email : "",
                    phone: props.compData.contactNo !== undefined ? props.compData.contactNo : state.get().phone ? state.get().phone : "",
                    compID: props.compData.ticketAllStarComplimentaryID,
                    status: props.compData.status ? props.compData.status : 0
                });
                setHideSubmitButton(true)
            }
            else {
                state.set({
                    name: state.get().name ? state.get().name : "",
                    email: state.get().email ? state.get().email : "",
                    phone: state.get().phone ? state.get().phone : "",
                    compID: "",
                    status: 0
                });
            }
        }
    }, [history, props?.compData])

    const reset = () => {
        state.set({
            name: '',
            email: '',
            phone: '',
            status: 0
        })
    };
    const onCompChange = (fieldName, val) => {
        let error = ''
        if (fieldName === 'name') {
            error = ticketHelper.CheckValidCompName(val);
            setCompNameError(error);
        }
        else if (fieldName === 'email') {
            error = ticketHelper.CheckValidCompEmail(val);
            setCompEmailError(error);
        }
        else {
            error = ticketHelper.CheckValidCompPhone(val);
            setCompPhoneError(error);
        }

        setHideSubmitButton(error && error.length > 0 ? true : false);
        let data = {
            ...state.get(),
            [fieldName]: val
        }
        //handleDisableButton(data);
        state.set(data);
        // props.onCompDataChange(data);
    }

    // const SETEmailNotification = (postCompData) =>
    // {
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     const userInfo = Helper.getStorage('userInfo');

    //     let emailFormData = new FormData();
    //     emailFormData.append('UserID', postCompData.userID);
    //     emailFormData.append('EventID', eventInfo.eventID)
    //     emailFormData.append('TemplateType', 'AllStarTicket')
    //     emailFormData.append('ID', postCompData.ticketAllStarComplimentaryID)
    //     emailFormData.append('ModifyBy', userInfo.userID)
    //     emailFormData.append('TranportType', '')
    //     emailFormData.append('ModuleID', 17)
    //     return ApiHelper.post(
    //         APIURLConstants.POST_TICKET_ALL_STAR_NOTIFICATION_EMAIL,
    //         emailFormData
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    const handleDisableButton = () => {

        let ticketInfo
        if (history.location.state && history.location.state.ticketState != null) {
            ticketInfo = history.location.state.ticketState;
        }
        // console.log("props?.compData",props?.compData);
        let prevData
        if (props?.compData !== null) {
            prevData = {
                name: props.compData.contactName !== undefined ? props.compData.contactName : "",
                email: props.compData.contactEmail !== undefined ? props.compData.contactEmail : "",
                phone: props.compData.contactNo !== undefined ? props.compData.contactNo : "",

            };
        } else {
            prevData = {
                name: ticketInfo && ticketInfo ? ticketInfo.contactName : '',
                email: ticketInfo && ticketInfo ? ticketInfo.contactEmail : '',
                phone: ticketInfo && ticketInfo ? ticketInfo.contactNo : '',
            };
        }
        // console.log('editHotelState : ', editHotelState);

        let currentData = {
            name: state.get().name,
            email: state.get().email,
            phone: state.get().phone,
        };
        // console.log(prevData);
        // console.log(currentData);
        // console.log(
        //     JSON.stringify(prevData) === JSON.stringify(currentData)
        // );
        if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
            setHideSubmitButton(true);
            props.setIsCompDirty(true);
        } else {
            setHideSubmitButton(false);
            props.setIsCompDirty(true);
        }
    }
    const handleCompSubmit = () => {
        // console.log("compCount",compCount);
        const userInfo = Helper.getStorage('userInfo');
        if ((props.agentInfo) &&
            (Helper.isAdminUser(props.agentInfo) ||
                (props.agentInfo.roles && Helper.isEventAdmin(props.agentInfo)) || (props.agentInfo.roles && Helper.isEventStaff(props.agentInfo)))
        ) {
            if (props.participant === null) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Select Participant first',
                });
                return;
            }
        } else if (
            (Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))) && !props.agentInfo
        ) {
            if (props.participant === null) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Select Participant first',
                });
                return;
            }
        }

        // if (compCount?.TicketSetting)
        // {
        //     if (JSON.parse(compCount?.TicketSetting)?.ticketFriCompCount <= '0' || JSON.parse(compCount?.TicketSetting)?.ticketSatCompCount <= '0' || JSON.parse(compCount?.TicketSetting)?.ticketSunCompCount <= '0')
        //     {
        //         props.setSnackBarProps({
        //             ...props.snackBarProps,
        //             openSnack: true,
        //             variant: 'error',
        //             message: 'Cannot add more than the allotted tickets request',
        //         });
        //         return;
        //     }
        // }else 
        if (!compCount?.TicketSetting) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Allotment is not configured.',
            });
            return;
        }
        const vNameError = ticketHelper.CheckValidCompName(state.name.get());
        const vEmailError = ticketHelper.CheckValidCompEmail(state.email.get());
        const vPhoneError = ticketHelper.CheckValidCompPhone(state.phone.get());

        if (vNameError || vEmailError || vPhoneError) {
            setCompNameError(vNameError);
            setCompEmailError(vEmailError);
            setCompPhoneError(vPhoneError);
            return;
        }
        const postCompData = ticketHelper.GenerateCompPostObject(state, props.participant, props.agentInfo, compCount, props.isAdminUser);
        //console.log("i m into submit", postCompData);

        ApiHelper.post(APIURLConstants.POST_ALLSTAR_EVENT_COMP_TICKETS, postCompData)
            .then(async (res) => {
                props.setIsCompDirty(true);
                if (res.data > 0) {
                    setHideSubmitButton(true)
                    props.onCompSave(hideSubmitButton)
                    // state.isDisable.set(false);
                    props.getPurchaseData(props.participant?.userID ? props.participant?.userID : userInfo.userID)
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Complimentary Ticket Saved successfully',
                    });
                    //if(state.compID.get()) { SETEmailNotification(postCompData) } 
                    await updateModuleState()
                }
                else {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'This user does not have permission for all star tickets request',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });

    }
    // console.log(userInfo);
    return (
        <>
            <Box>
                <AppBar position="static" color="default" sx={appBarStyle}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={15}
                        fontWeight={700}
                        fontFamily={'Lato'}
                        noWrap
                        fontStyle="normal"
                        color='primary'
                        component="div"
                        sx={{
                            ml: 1,
                        }}
                    >
                        Complimentary Tickets
                    </Typography>
                    {/* <Title
                        title={'Complimentary Tickets'}
                        // addicon="land"
                        sx={{
                            ml: 1,
                        }}
                    /> */}
                </AppBar>
                <TableContainer component={Paper}>
                    {compCount.CInstruction ? <Box sx={{ mb: 2, ml: 2 }}>{compCount.CInstruction}</Box> : null}
                    <Divider />
                    <Table sx={{ minWidth: 350 }} aria-label="simple table">
                        <TableHead >
                            <TableRow>
                                <TableCell className={classes.borderSizeColor} align="center">Friday Night</TableCell>
                                <TableCell className={classes.borderSizeColor} align="center">Saturday Night</TableCell>
                                <TableCell className={classes.borderSizeColor} align="center">Sunday Night</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row" align="center">
                                    {/* {
                                        (Object.keys(props.compData || {}).length === 0) ?
                                            (compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketFriCompCount : 0)
                                            : 0} */}
                                {compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketFriCompCount : 0}
                                </TableCell>
                                <TableCell align="center">
                                    {/* {(Object.keys(props.compData || {}).length === 0) ?
                                        (compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSatCompCount : 0)
                                        : 0} */}
                                        {compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSatCompCount : 0}
                                </TableCell>
                                <TableCell align="center">
                                    {/* {(Object.keys(props.compData || {}).length === 0) ?
                                        (compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSunCompCount : 0)
                                        : 0} */}
                                        {compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSunCompCount : 0}
                                </TableCell>
                            </TableRow>

                        </TableBody>

                    </Table>
                </TableContainer>
                <Box sx={{ pl: 2, pt: 2 }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={15}
                        fontWeight={700}
                        fontFamily={'Lato'}
                        noWrap
                        fontStyle="normal"
                        color='primary'
                        component="div"
                        sx={{
                            ml: 1,
                        }}
                    >Ticket Contact</Typography>
                </Box>

                <Box sx={{ mt: 2 }} display={'flex'} flexDirection={'row'} >
                    <TextField
                        fullWidth
                        required
                        sx={{
                            width: {
                                xs: '100%',
                                md: '33%',
                            },
                            paddingRight: 2
                        }}
                        size="small"
                        id="outlined-required"
                        inputProps={{ maxLength: 50 }}
                        value={state.get().name}
                        onChange={(e) => {
                            onCompChange('name', e.target.value);
                            handleDisableButton()
                        }}
                        label="Name"
                        error={
                            compNameError.length > 0
                                ? true
                                : false
                        }
                        helperText={
                            compNameError.length > 0
                                ? compNameError
                                : ''
                        }
                    />
                    <TextField
                        fullWidth
                        required
                        sx={{
                            width: {
                                xs: '100%',
                                md: '33%',
                            },
                            paddingRight: 2
                        }}
                        size="small"
                        id="outlined-required"
                        inputProps={{ maxLength: 50 }}
                        value={state.get().email}
                        onChange={(e) => {
                            onCompChange('email', e.target.value);
                            handleDisableButton()
                        }}
                        label="Email"
                        error={
                            compEmailError.length > 0
                                ? true
                                : false
                        }
                        helperText={
                            compEmailError.length > 0
                                ? compEmailError
                                : ''
                        }
                    />
                    {/* <InputMask
                        mask="(999) 999-9999"
                        value={state.get().phone}
                        // defaultValue={state.contactNumber
                        // .attach(Downgraded)
                        // .get()}
                        onChange={(e) =>
                        {
                            const ph = e.target.value;
                            state.phone.set(ph);
                            onPhoneChange(ph);
                        }}
                    // onBlur={checkValidPhone}
                    >
                        {() => (
                            <TextField
                                size="small"
                                fullWidth
                                required
                                label="Phone"
                                // id="outlined-basic"
                                variant="outlined"
                                value={state.get().phone}
                                sx={{
                                    width: {
                                        xs: '100%',
                                        md: '33%',
                                    },
                                    // marginTop: 2,
                                    // marginRight: 2,
                                    // marginBottom: 2,
                                }}
                                error={
                                    compPhoneError.length > 0
                                        ? true
                                        : false
                                }
                                helperText={
                                    compPhoneError.length > 0
                                        ? compPhoneError
                                        : ''
                                }
                            />
                        )}
                    </InputMask> */}
                    <Box sx={{ width: '33%' }}>
                        <PhoneNumber
                            name={'CompContact'}
                            placeholder="Phone"
                            value={state.phone.get()}
                            onChange={(ph) => {
                                onCompChange('phone', ph);
                                handleDisableButton()
                            }}
                            required={true}
                            helperText={compPhoneError}
                            error={compPhoneError.length > 0 ? true : false}
                        />
                    </Box>
                </Box>
                <Box component="div"
                    sx={{
                        display: 'flex',
                        alignItems: "right",
                        justifyContent: 'right',
                        mt: 1
                    }}>
                    <Button
                        variant="contained"
                        onClick={handleCompSubmit}
                        disabled={(eventInfo.readonlyOrHide === 1 ? true : props.modPermission === VIEW_PERMISSION ? true : hideSubmitButton)}
                    >Save</Button>
                </Box>
            </Box>
        </>
    );
};

export default Complimentary;